import apiClient from "../../utils/apiClient";

const API_URL = "/admin/users";

export async function adminLogin(credentials) {
    try {
        const response = await apiClient.post(`/admin/login`, credentials);
        return response.data;
    } catch (error) {
        console.error("Admin login error:", error);
        throw error;
    }
}

export async function adminForgotPassword(email) {
    try {
        const response = await apiClient.post(`/admin/forgot-password`, { email });
        return response.data;
    } catch (error) {
        console.error("Admin forgot password error:", error);
        throw error;
    }
}

export async function adminVerifyOTP(email, otp) {
    try {
        const response = await apiClient.post(`/admin/verify-otp`, { email, otp });
        return response.data;
    } catch (error) {
        console.error("Admin verify OTP error:", error);
        throw error;
    }
}

export async function adminUpdatePassword(adminId, newPassword) {
    try {
        const response = await apiClient.post(`/admin/update-password`, { adminId, newPassword });
        return response.data;
    } catch (error) {
        console.error("Admin update password error:", error);
        throw error;
    }
}

export async function getAllUsers() {
    try {
        const response = await apiClient.get(`${API_URL}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
}

export async function verifyuser(userId, statusObj) {
    try {
        const response = await apiClient.put(`${API_URL}/verify/${userId}`, statusObj);
        return response.data;
    } catch (error) {
        console.error("Error verifying user:", error);
        throw error;
    }
}

export async function userProfile(userId) {
    try {
        const response = await apiClient.get(`${API_URL}/profile/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user profile:", error);
        throw error;
    }
}

export async function userApplications(userId) {
    try {
        const response = await apiClient.get(`${API_URL}/applications/${userId}`);
        // If no applications found, return empty array instead of throwing error
        if (response.data && (response.data.length === 0 || (response.data.applications && response.data.applications.length === 0))) {
            return [];
        }
        return response.data;
    } catch (error) {
        // Check if it's a "no applications found" error (404 or similar)
        if (error.response && (error.response.status === 404 || error.response.data?.message?.includes('No applications'))) {
            // Return empty array instead of throwing error to avoid toast notification
            return [];
        }
        console.error("Error fetching user applications:", error);
        throw error;
    }
}

export async function getPendingPasswordResets() {
    try {
        const response = await apiClient.get(`${API_URL}/password-reset-pending`);
        return response.data;
    } catch (error) {
        console.error("Error fetching pending password resets:", error);
        throw error;
    }
}

export async function adminResetPassword(userId) {
    try {
        const response = await apiClient.post(`${API_URL}/reset-password/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error resetting password:", error);
        throw error;
    }
}

export async function deleteUser(userId) {
    try {
        const response = await apiClient.delete(`${API_URL}/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
    }
}

export async function getEmployees() {
    const response = await apiClient.get('/admin/employees');
    return response.data;
}

export async function createEmployee(employeeData) {
    const response = await apiClient.post('/admin/employees', employeeData);
    return response.data;
}

export async function updateEmployee(employeeId, employeeData) {
    const response = await apiClient.put(`/admin/employees/${employeeId}`, employeeData);
    return response.data;
}

export async function deleteEmployee(employeeId) {
    const response = await apiClient.delete(`/admin/employees/${employeeId}`);
    return response.data;
}